import { RequestBodyType, RequestMethod } from 'lib/api-types';
import { baseApiUrl } from 'redux/reducers/settings';

const baseUrl = baseApiUrl;

export const adminApi = {
  // Existing API
  UpadateMark: {
    actionName: 'UPDATE_MARKS',
    controllerName: `${baseUrl}evaluation/assign-marks/{newId}`,
    requestMethod: RequestMethod.PATCH
  },

  // New App Configuration APIs
  CreateAppConfig: {
    actionName: 'CREATE_APP_CONFIG',
    controllerName: `${baseUrl}appconfiguration/appconfiguration/create`,
    requestMethod: RequestMethod.POST
  },
  UpdateAppConfig: {
    actionName: 'UPDATE_APP_CONFIG',
    controllerName: `${baseUrl}appconfiguration/appconfiguration/update/{id}`,
    requestMethod: RequestMethod.PATCH,
    requestBodyType: RequestBodyType.FORM_DATA
  },
  DeleteAppConfig: {
    actionName: 'DELETE_APP_CONFIG',
    controllerName: `${baseUrl}appconfiguration/appconfiguration/delete/{id}`,
    requestMethod: RequestMethod.DELETE
  },
  GetAppConfigList: {
    actionName: 'GET_APP_CONFIG_LIST',
    controllerName: `${baseUrl}appconfiguration/appconfiguration/list`,
    requestMethod: RequestMethod.GET
  },
  GetAppConfigByDomain: {
    actionName: 'GET_APP_CONFIG_BY_DOMAIN',
    controllerName: `${baseUrl}appconfiguration/appconfiguration/getbydomain`,
    requestMethod: RequestMethod.GET
  },
  BulkCreateTrainee: {
    actionName: 'GET_BLUK_CREATE_TRAINEE',
    controllerName: `${baseUrl}users/trainee-registration/bulk`,
    requestMethod: RequestMethod.POST
  },
  GetUserTrainee: {
    actionName: 'GET_USER_TRAINEE_LIST',
    controllerName: `${baseUrl}users/trainee/view`,
    requestMethod: RequestMethod.GET
  },

  activeRoutine: {
    actionName: 'GET_ACTIVE_ROUTINE',
    controllerName: `${baseUrl}users/admin/routines/active`,
    requestMethod: RequestMethod.GET
  },
  getRoutineReportById: {
    actionName: 'GET_ROUTINE_REPORT_BY_ID',
    controllerName: `${baseUrl}reports/reports/{routineId}`,
    requestMethod: RequestMethod.GET
  },
  getlistTraining: {
    actionName: 'GET_LIST_TRAINING',
    controllerName: `${baseUrl}training/`,
    requestMethod: RequestMethod.GET
  },
  getTraineeProfileList: {
    actionName: 'GET_TRAINEE_PROFILE_LIST',
    controllerName: `${baseUrl}reports/GetTraineeFullDetailsByRoutine`,
    requestMethod: RequestMethod.GET
  },
  getRoutineDetails: {
    actionName: 'GET_ROUTINE_DETAILS',
    controllerName: `${baseUrl}training/routine-master/{routineId}`,
    requestMethod: RequestMethod.GET
  },
  getTraineeAttendance: {
    actionName: 'GET_TRAINEE_ATTENDANCE',
    controllerName: `${baseUrl}reports/GetTraineeAttendanceDetailsByRoutine`,
    requestMethod: RequestMethod.GET
  },
  getRoutineCourseDetail: {
    actionName: 'GET_ROUTINE_COURSE_DETAIL',
    controllerName: `${baseUrl}training/routine/courses/{routineId}`,
    requestMethod: RequestMethod.GET
  },
  getAllRoutineList: {
    actionName: 'GET_ALL_ROUTINE_LIST',
    controllerName: `${baseUrl}training/dropdownall/routinemaster`,
    requestMethod: RequestMethod.GET
  },
  getAllActiveCourseList: {
    actionName: 'GET_ALL_ACTIVE_COURSE_LIST',
    controllerName: `${baseUrl}training/dropdown/course`,
    requestMethod: RequestMethod.GET
  },
  getAllActiveTrainingList: {
    actionName: 'GET_ALL_ACTIVE_TRAINING_LIST',
    controllerName: `${baseUrl}training/dropdown/training`,
    requestMethod: RequestMethod.GET
  },
  getAvailableUserList: {
    actionName: 'GET_ALL_AVAILABLE_USER_LIST',
    controllerName: `${baseUrl}users/admin/available/list`,
    requestMethod: RequestMethod.GET
  },
  getAdminList: {
    actionName: 'GET_ALL_ADMIN_LIST',
    controllerName: `${baseUrl}users/admin/list/`,
    requestMethod: RequestMethod.GET
  },
  addImage: {
    actionName: 'ADD_IMAGE',
    controllerName: `${baseUrl}reports/gallery-routine/create`,
    requestMethod: RequestMethod.POST,
    requestBodyType: RequestBodyType.FORM_DATA
  },
  addMultipleImage: {
    actionName: 'ADD_MULTIPLE_IMAGE',
    controllerName: `${baseUrl}reports/gallery-routine/create-multiple`,
    requestMethod: RequestMethod.POST,
    requestBodyType: RequestBodyType.FORM_DATA
  },
  assignImageToRoutine: {
    actionName: 'ASSIGN_IMAGE_TO_ROUTINE',
    controllerName: `${baseUrl}reports/gallery-routine/assign`,
    requestMethod: RequestMethod.POST,
  },
  saveRoutineReport: {
    actionName: 'SAVE_ROUTINE_REPORT',
    controllerName: `${baseUrl}reports/save/routine/{id}`,
    requestMethod: RequestMethod.POST,
  }
};
